.cms-svg-icon-wrapper {
  display: flex;
  align-items: center;
  flex-wrap: wrap;

  > svg {
    width: 100%;
    height: auto;
  }
}
